import { Card, CardContent, CardHeader } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

/**
 * OKS-38 — Loading state for the Upcoming Deadlines panel. 3 skeleton
 * rows matching deadline-row geometry so the Retry round-trip doesn't
 * shift layout (UX Spec §3 lock).
 */
export function DashboardDeadlinesSkeleton() {
  return (
    <section
      aria-busy="true"
      aria-label="Loading upcoming deadlines"
      data-testid="dashboard-deadlines-skeleton"
    >
      <Card className="rounded-xl border">
        <CardHeader>
          <Skeleton className="h-5 w-44" />
          <Skeleton className="mt-1 h-3 w-32" />
        </CardHeader>
        <CardContent>
          <ul className="flex flex-col gap-1">
            {Array.from({ length: 3 }).map((_, i) => (
              <li
                key={i}
                className="flex min-h-11 items-center justify-between gap-4 rounded-md px-3 py-2"
              >
                <div className="flex min-w-0 flex-1 flex-col gap-1.5">
                  <Skeleton className="h-4 w-3/5" />
                  <Skeleton className="h-3 w-24" />
                </div>
                <Skeleton className="h-6 w-20 shrink-0 rounded-md" />
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </section>
  )
}
